import { useToast } from '@/hooks/use-toast';
import { useApolloClient } from '@apollo/client';
import { GET_CAMPAIGNS } from '../../../queries/campaigns';
import { ActionDialog } from './action-dialog';
import { useUpdateCampaignStatus } from '../hooks/use-campaigns';
import { CampaignStatus } from '@/gql/graphql';

interface PauseCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  campaignId: string;
  campaignName: string;
}

export function PauseCampaignDialog({
  open,
  onOpenChange,
  campaignId,
  campaignName
}: PauseCampaignDialogProps) {
  const { toast } = useToast();
  const { update, loading } = useUpdateCampaignStatus();
  const client = useApolloClient();

  const handlePause = async () => {
    try {
      await update(campaignId, CampaignStatus.Paused);
      // Force refetch campaigns
      await client.refetchQueries({
        include: [GET_CAMPAIGNS]
      });
      toast({
        title: 'Success',
        description: 'Campaign paused successfully.'
      });
      onOpenChange(false);
    } catch (_error) {
      toast({
        title: 'Error',
        description: 'Failed to pause campaign. Please try again.',
        variant: 'destructive'
      });
    }
  };

  return (
    <ActionDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Pause Campaign"
      description={`Are you sure you want to pause the campaign "${campaignName}"? You can resume it later.`}
      actionLabel="Pause Campaign"
      loadingLabel="Pausing..."
      onAction={handlePause}
      loading={loading}
    />
  );
}
